import React from 'react';

/**
 * Public landing page shown after a practice clicks the SES email-verification
 * link. AWS SES does the actual verification on its own servers, then redirects
 * the browser here (SuccessRedirectionURL / FailureRedirectionURL on the
 * `deskbot-practice-verification` custom template). This page is purely a
 * branded confirmation message — no auth, no API calls, no state. Mounted at
 * two public routes in App.js: /email-bestaetigt (success) and
 * /email-fehlgeschlagen (failure).
 */
const EmailVerificationResult = ({ status = 'success' }) => {
  const ok = status === 'success';
  // Brand palette from App.css (green --color-quaternary / coral --color-tertiary),
  // linked via CSS vars so the page follows any future palette retune.
  const accent = ok ? 'var(--color-quaternary)' : 'var(--color-tertiary)';
  const accentTint = `color-mix(in srgb, ${accent} 13%, transparent)`;

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#f4f6f9',
        padding: '1.5rem',
        fontFamily: 'Inter, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif',
      }}
    >
      <div
        style={{
          background: '#ffffff',
          borderRadius: '14px',
          boxShadow: '0 10px 40px rgba(27, 63, 101, 0.12)',
          padding: '2.5rem 2rem',
          maxWidth: '440px',
          width: '100%',
          textAlign: 'center',
        }}
      >
        <img
          src="/Deskbot-newlogo-favicon.png"
          alt="DeskBot"
          style={{ height: '44px', width: '44px', marginBottom: '1.25rem' }}
        />
        <div
          style={{
            width: '64px',
            height: '64px',
            borderRadius: '50%',
            background: accentTint,
            color: accent,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '2rem',
            margin: '0 auto 1.25rem',
          }}
          aria-hidden="true"
        >
          {ok ? '✓' : '!'}
        </div>
        <h1 style={{ color: 'var(--color-main)', fontSize: '1.4rem', fontWeight: 700, margin: '0 0 0.75rem' }}>
          {ok ? 'E-Mail-Adresse bestätigt' : 'Bestätigung fehlgeschlagen'}
        </h1>
        <p style={{ color: '#4a5568', fontSize: '1rem', lineHeight: 1.6, margin: 0 }}>
          {ok
            ? 'DeskBot kann nun Terminbestätigungen im Namen Ihrer Praxis versenden. Sie können dieses Fenster schließen.'
            : 'Der Bestätigungslink ist abgelaufen oder ungültig. Bitte fordern Sie in den Praxis-Einstellungen eine neue Bestätigung an.'}
        </p>
      </div>
    </div>
  );
};

export default EmailVerificationResult;
